import React,{useState,useEffect} from 'react'
import loader from '../Img/loader.gif'
import './GalleryComponent.css'
import { invokeGallery } from '../ServiceCalls/ApiCalls'

function GalleryComponent() {
  
  const[gallery,setGallery] = useState([])
  const[modalPreview,setModalPreview] = useState(false)
  const[tempImgSrc,setTempImgSrc] = useState('')
  
  useEffect(() => {
    async function getGallery(){
        const gallery_list = await invokeGallery();
        console.log(gallery_list)
        setGallery([...gallery_list])
    }

    getGallery()

  },[])

  // Effect to handle body scroll lock
  useEffect(() => {
    if (modalPreview) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }

    // Cleanup function to remove class when component unmounts
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, [modalPreview])

  const getImage = (imgSrc) =>{
    setTempImgSrc(imgSrc)
    setModalPreview(true)
  }
  return (
    <div className="gallery-page">
      <div className="container admin-container">
        {/* Gallery Header */}
        <div className="row mt-5">
          <div className="col-md-12">
            <div className="gallery-header">
              <h3 className="mb-1">
                <i className="fa fa-images text-warning me-2"></i>
                Image Gallery
              </h3>
              <p className="text-muted">Explore our badminton facilities and memorable moments</p>
              <div className="gallery-stats">
                <span className="gallery-count">
                  <i className="fa fa-camera text-primary me-1"></i>
                  {gallery.length} {gallery.length === 1 ? 'Image' : 'Images'}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Gallery Content */}
        {modalPreview ? (
          <div className='modal-preview'>
            <div className="modal-overlay" onClick={() => setModalPreview(false)}>
              <div className="modal-container" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                  <h5 className="modal-title">
                    <i className="fa fa-image text-warning me-2"></i>
                    Image Preview
                  </h5>
                  <button
                    onClick={() => setModalPreview(false)}
                    className='modal-close-btn'
                    aria-label="Close">
                    <i className="fa fa-times"></i>
                  </button>
                </div>
                <div className="modal-image-container">
                  <img src={tempImgSrc} alt="Gallery preview" className="modal-image" />
                </div>
                <div className="modal-footer">
                  <button
                    onClick={() => setModalPreview(false)}
                    className='btn btn-secondary'>
                    <i className="fa fa-times me-2"></i>
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="gallery-content">
            {gallery.length > 0 ? (
              <div className="gallery-grid">
                {gallery.map((img, index) => {
                  const blob = img?.gallery_pic?.data?.data ? new Blob([Int8Array.from(img?.gallery_pic?.data?.data)], {type: img?.gallery_pic?.contentType }) : null;
                  const image = blob ? window.URL.createObjectURL(blob) : null;
                
                  return (
                    <div className="gallery-item" key={index} onClick={() => getImage(image)}>
                      <div className="gallery-image-container">
                        <img src={image} alt={`Gallery ${index + 1}`} loading="lazy" className="gallery-image" />
                        <div className="gallery-overlay">
                          <div className="gallery-overlay-content">
                            <i className="fa fa-search-plus fa-2x"></i>
                            <p>Click to view</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="gallery-empty">
                <div className="empty-state">
                  <div className="empty-icon">
                    <i className="fa fa-images fa-4x text-muted"></i>
                  </div>
                  <h4 className="empty-title">No Images Available</h4>
                  <p className="empty-description">
                    The gallery is currently empty. Images will appear here once they are uploaded by administrators.
                  </p>
                  <div className="loading-indicator">
                    <img src={loader} alt="Loading..." className="loader-image" />
                    <p className="loading-text">Loading gallery...</p>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default GalleryComponent